import { BRAND } from "../lib/constants";
import { BookNowButton } from "./Shared";
import { Briefcase, ArrowUpRight } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/10 bg-black"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 pt-10">
        {/* Careers strip */}
        <a
          href={`mailto:${BRAND.email}?subject=Careers%20Inquiry%20-%20The%20Neat%20Lab`}
          data-testid="careers-cta"
          className="group flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 rounded-2xl border border-white/10 bg-gradient-to-r from-[#0A0A0A] to-black p-5 sm:p-6 hover:border-[#00E5FF]/40 transition-all"
        >
          <div className="flex items-center gap-4">
            <div className="h-11 w-11 rounded-full bg-[#00E5FF]/10 flex items-center justify-center text-[#00E5FF] shrink-0">
              <Briefcase size={18} />
            </div>
            <div>
              <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40">
                Join the Lab
              </div>
              <div className="mt-1 font-display text-lg sm:text-xl font-semibold text-white leading-snug">
                Interested in a career with The Neat Lab?
              </div>
              <div className="mt-1 text-sm text-white/55 font-body">
                Email us at{" "}
                <span className="text-[#00E5FF]">{BRAND.email}</span> to inquire.
              </div>
            </div>
          </div>
          <span className="inline-flex items-center gap-2 text-sm font-body text-white/70 group-hover:text-[#00E5FF] transition-colors shrink-0">
            Apply now
            <ArrowUpRight
              size={16}
              className="group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform"
            />
          </span>
        </a>
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src={BRAND.logo}
                alt="The Neat Lab"
                className="h-12 w-12 rounded-full object-cover ring-1 ring-white/10"
              />
              <div>
                <div className="font-display text-xl font-semibold">
                  The <span className="text-[#00E5FF]">Neat</span> Lab
                </div>
                <div className="text-xs font-mono uppercase tracking-[0.2em] text-white/40 mt-0.5">
                  Formulated cleanliness
                </div>
              </div>
            </div>
            <p className="mt-5 text-white/50 font-body text-sm leading-relaxed max-w-sm">
              Precision residential and exterior cleaning. Booked online,
              delivered on time, verified by protocol.
            </p>
            <div className="mt-6">
              <BookNowButton variant="primary" testId="footer-book-now" />
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40">
              Navigate
            </div>
            <ul className="mt-5 space-y-3 font-body text-sm">
              {[
                ["Services", "#services"],
                ["Process", "#process"],
                ["About", "#about"],
                ["Contact", "#contact"],
              ].map(([label, href]) => (
                <li key={href}>
                  <a
                    href={href}
                    data-testid={`footer-link-${label.toLowerCase()}`}
                    className="text-white/70 hover:text-[#00E5FF] transition-colors"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40">
              Contact
            </div>
            <ul className="mt-5 space-y-3 font-body text-sm">
              <li>
                <a
                  href={BRAND.phoneLink}
                  data-testid="footer-phone"
                  className="text-white/70 hover:text-[#00E5FF] transition-colors"
                >
                  {BRAND.phone}
                </a>
              </li>
              <li>
                <a
                  href={BRAND.emailLink}
                  data-testid="footer-email"
                  className="text-white/70 hover:text-[#00E5FF] transition-colors break-all"
                >
                  {BRAND.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
          <p className="text-xs text-white/40 font-mono uppercase tracking-[0.18em]">
            © {new Date().getFullYear()} The Neat Lab LLC · All rights reserved
          </p>
          <p className="text-xs text-white/40 font-mono uppercase tracking-[0.18em]">
            Built with precision
          </p>
        </div>
      </div>
    </footer>
  );
};
